import React from "react";
import { Button, Modal } from "react-bootstrap";

/**
 * A modal dialog that will pop up with the status of the user's offer claim.
 *
 * @param show - Boolean state indicating if the modal should be displayed
 * @param handleClose - Function to call when the user clicks to close the modal
 * @param orderData - The data returned from the server regarding the user's offer claim
 * @returns {Element} - A modal dialog to display the status of their offer claim
 */
const ClaimStatusOverlay = ({ show, handleClose, orderData }) => {
  return (
    <>
      <Modal show={show} onHide={handleClose} size="md" centered backdrop="static" id="claimStatusWindow" keyboard={false}>
        <Modal.Header>
          <span className="close" onClick={handleClose}>&times;</span>
          <Modal.Title className="claim-status-modal-header">
            {(orderData && orderData.giftcardListPending?.length === 0 &&
              orderData.giftcardListPending?.length === 0) ? "SUCCESS" : "PENDING"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="login-modal-body">
            {orderData && orderData.giftcardListPending?.length === 0 &&
              orderData.giftcardListFailed?.length === 0 && (
                <p className="successful-claim-text">
                  {process.env.REACT_APP_CLAIM_SUCCESS_MESSAGE}
                </p>
              )}
            {orderData && (orderData.giftcardListPending?.length > 0 ||
              orderData.giftcardListFailed?.length > 0) && (
              <p className="unsuccessful-claim-text">
                Some of your offers are still processing. Please check back again later.
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-primary login-modal-button sigmar-center-element" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ClaimStatusOverlay;
